import React from 'react';
// import flexible from '../../utils/flexible';
import './index.less';
import pic1 from './img/20200506-1.png';
import pic2 from './img/20200506-2.png';
import pic3 from './img/20200506-3.png';
import pic4 from './img/20200506-4.jpg';
import pic5 from './img/icon1.png';

class huilian56 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <div id="banner" className="banner56">
        <img src={pic1} />
        <img src={pic2} />

        <div className="bottom-view">
          <img src={pic3} />
          <div className="city-phone-view">
            <div className="city-phone">
              <div className="left-text">深圳</div>
              <div>咨询热线：</div><a href="tel:18650849901">18650849901</a><div className="right-text">( 微信同号 )</div>
            </div>
            <div className="city-phone">
              <div className="left-text">杭州</div>
              <div>咨询热线：</div><a href="tel:15558008702">15558008702</a><div className="right-text">( 微信同号 )</div>
            </div>
            <div className="city-phone">
              <div className="left-text">长沙</div>
              <div>咨询热线：</div><a href="tel:18608408156">18608408156</a><div className="right-text">( 微信同号 )</div>
            </div>
          </div>

        </div>

        <img src={pic4} />

      </div>
    );
  }
}

export default huilian56;



// WEBPACK FOOTER //
// ./src/staticPage/banner/20200506/index.js